export const EQUALS = 'EQUALS';
export const DOES_NOT_EQUAL = 'DOES_NOT_EQUAL';
export const GREATER_THAN = 'GREATER_THAN';
export const LESS_THAN = 'LESS_THAN';

export const COMPARATOR_LABEL_BY_VALUE = {
  [EQUALS]: 'Equals',
  [DOES_NOT_EQUAL]: 'Does not equal',
  [GREATER_THAN]: 'Greater than',
  [LESS_THAN]: 'Less than',
};

export const COMPARATOR_OPTIONS = Object.keys(COMPARATOR_LABEL_BY_VALUE).map((key) => ({
  // @ts-ignore
  label: COMPARATOR_LABEL_BY_VALUE[key],
  value: key
}));

export const GET = 'GET';
export const POST = 'POST';
export const PATCH = 'PATCH';
export const PUT = 'PUT';

export const HTTP_METHOD_LABEL_BY_VALUE = {
  [GET]: 'Get',
  [POST]: 'Post',
  [PATCH]: 'Patch',
  [PUT]: 'Put',
};

export const HTTP_METHOD_OPTIONS = Object.keys(HTTP_METHOD_LABEL_BY_VALUE).map((key) => ({
  // @ts-ignore
  label: HTTP_METHOD_LABEL_BY_VALUE[key],
  value: key
}));
